var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-background d-flex align-items-center justify-content-center"},[_c('amplify-authenticator',{attrs:{"username-alias":"email"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }